import './quoteBox.css';
import React from 'react';
import { ImageData } from './../CommonTypes';

export interface QuoteBoxType {
	quoteIconUrl: string;
	quote: string;
	signature: string;
	imageData: ImageData;
}

export const QuoteBox = ({ props }: { props: QuoteBoxType }) => {
	return (
		<div className="quote-box">
			<div>
				<img src={props.quoteIconUrl} alt="" />
				<div>
					<p>&laquo;{props.quote}&raquo;</p>
					<p>
						<small>{props.signature}</small>
					</p>
				</div>
			</div>
			<img src={props.imageData.url} alt={props.imageData.altText} />
		</div>
	);
};
